// extracted by mini-css-extract-plugin
export default {"customHeaderTitle":"CustomHeaderTitle_customHeaderTitle__JDpav","backButton":"CustomHeaderTitle_backButton__GeoQX"};